import {Col, Form, Row} from "react-bootstrap";
import React from "react";

export default function CpmRangeInput({cpmRange, onValueChange, isToDisabled, showRange}) {
  return (
    <Row className="mb-2">
      { showRange && <>
        <Col>
          <Form.Control type="number" step="1" value={cpmRange.from} disabled={true} onChange={(e) => onValueChange("from", e.target.value)} />
        </Col>
        <Col>
          <Form.Control type="number" step="1" value={cpmRange.to} disabled={isToDisabled} onChange={(e) => onValueChange("to", e.target.value)} />
        </Col>
      </>}
      <Col>
        <Form.Control type="number" step="0.1" value={cpmRange.value} onChange={(e) => onValueChange("value", e.target.value)} />
      </Col>
    </Row>
  )
}
